import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FaDelicious, FaUser, FaFolder, FaCloudUploadAlt, FaClipboardList, FaGlobe, FaSearch, FaBook } from 'react-icons/fa';
import { BsPeopleFill, BsPersonPlus, BsPersonCheckFill, BsFilesAlt, BsFiles, BsPersonCircle, BsFileEarmark } from "react-icons/bs";
import { FaUsers } from "react-icons/fa6";
import { MdGroupAdd } from "react-icons/md";
// import { motion } from "framer-motion";
import { useAuth } from "../security/authContext.js"

import "../SideBar/SideBar.css"
import logo from "../../assets/images/TR-logo.png";
import logo_mini from "../../assets/images/logo-mini.png";


const SideBarCommon = ({ collapsed, menuItems, isMobile, onToggleSidebar }) => {
  const [active, setActive] = useState('Reports');
  const [openMenus, setOpenMenus] = useState({});
  const { hasPermission } = useAuth();

  const toggleSubmenu = (name) => {
    setOpenMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  }
console.log("isMobile:", isMobile);

  const handleMenuClick = () => {
      if (isMobile) {
          onToggleSidebar();
      }
  };

  return (
    <div className="sideBar">
      <div className='logo' style={{ display: isMobile ? 'none' : 'block' }}> <Link to="/dashboard">{collapsed ? <img src={logo_mini} /> : <img src={logo} />} </Link></div>
      <ul initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.2 }} className="list-unstyled parentList">
        {
          menuItems.map((navItems, index) => {
            // Filter allowed children
            const allowedChildren = navItems.children?.filter(
              (subItem) => !subItem.permission || hasPermission(subItem.permission)
            );

            // Check if parent should be shown
            const shouldShowParent =
              !navItems.permission || hasPermission(navItems.permission);

            // If parent has children but none are allowed → don't render
            if (navItems.children && (!allowedChildren || allowedChildren.length === 0)) {
              return null;
            }

            return (
              <li key={index}>
                {
                  !navItems.children ? (
                    shouldShowParent && (
                      <NavLink to={navItems.path} className={active === navItems.name ? "active" : ""} onClick={handleMenuClick}>
                        <span className="icon">{navItems.icon}</span>
                        <span className="name" style={{ display: collapsed ? 'none' : 'block' }}>
                          {navItems.name}
                        </span>
                      </NavLink>
                    )
                  ) : (
                    shouldShowParent && (
                      <>
                        <a className="nav-link d-flex justify-content-between" onClick={() => toggleSubmenu(navItems.name)} style={{ cursor: "pointer" }}>
                          <div style={{ display: "flex" }}>
                            
                              <span className="icon">{navItems.icon}</span>
                           
                            <span className="name" style={{ display: collapsed ? 'none' : 'block' }}>
                              {navItems.name}
                            </span>
                          </div>
                          { !collapsed && (
                          <span className="icon">
                            {openMenus[navItems.name] ? '-' : '+'}
                          </span>
                           )
                          }
                        </a>

                        <ul className={`submenu list-unstyled ${collapsed ? "" : "ps-4"} ${openMenus[navItems.name] ? 'show' : 'd-none'}`}>
                          {allowedChildren.map((subItem, subIndex) => (
                            <li key={subIndex}>
                              <NavLink to={subItem.path} className="nav-link" end={true}  onClick={handleMenuClick}>
                                <span className="icon">{subItem.icon}</span>
                                <span className="name" style={{ display: collapsed ? 'none' : 'block' }}>
                                  {subItem.name}
                                </span>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </>
                    )
                  )
                }
              </li>
            );
          })
        }
      </ul>
    </div>
  );
}

export default SideBarCommon;